/* eslint-disable no-param-reassign */
import TeamSettingsPaywallApi from '@/api/teamSettingsPaywall'
import sentry from '@/services/sentry'

const SET_LOADING = 'SET_LOADING'

const STORAGE_KEY_PREFIX = 'aha_team_settings_request_sent_'

const getStorageKey = (accountId) => `${STORAGE_KEY_PREFIX}${accountId}`

const isRequestSent = (accountId) => {
  try {
    return localStorage.getItem(getStorageKey(accountId)) === 'true'
  } catch {
    return false
  }
}

const markRequestSent = (accountId) => {
  try {
    localStorage.setItem(getStorageKey(accountId), 'true')
  } catch {
    // localStorage unavailable (AC-E02) — silently ignore
  }
}

const _state = {
  isLoading: false,
}

const getters = {
  isLoading: (state) => state.isLoading,
}

const actions = {
  async sendTeamSettingsFeatureRequestAction({ commit, rootState }, settingName) {
    try {
      commit(SET_LOADING, true)
      const result = await TeamSettingsPaywallApi.sendFeatureRequest(settingName)
      markRequestSent(rootState.currentAccount.id)
      return result
    } catch (error) {
      sentry.captureException(error)
      throw error
    } finally {
      commit(SET_LOADING, false)
    }
  },
  checkRequestAlreadySent(_, accountId) {
    return isRequestSent(accountId)
  },
}

const mutations = {
  [SET_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
}

const teamSettingsPaywall = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default teamSettingsPaywall
